import React from "react";
//import HomePage from "./HomePage";
import CustomerHomePage from "./CustomerHomePage";

//import { FirebaseAuth } from "./context";

const RealHomePage = () => {
  return (
    // <FirebaseAuth>
    <div>
      {/* <HomePage /> */}
      <CustomerHomePage />
    </div>
    // </FirebaseAuth>
  );
};
export default RealHomePage;
